import React from 'react';
import {BlockComponentProps} from 'client-react-block-renderer';
import {Icon, FloatingFooter} from 'forms';

type Props = BlockComponentProps<void, Config>;

interface Config {
    linkText: string;
    topId: string;
}

const ReturnToTopBlock = ({
    config: {
        topId,
        linkText,
    },
}: Props) => <FloatingFooter className="return-to-top">
    <a href={`#${topId}`}>
        <Icon icon="circle-arrow-up" />&nbsp;{linkText}
    </a>
</FloatingFooter>;

export default ReturnToTopBlock;
